import MeaButton from "../../../../components/MeaButton";
import MeaStudentStatus2 from "../../../../components/MeaStudentStatus2";
import { Menu } from "primereact/menu";
import { useRef } from "react";
import MeaStudentResult from "../../../../components/MeaStudentResult";
import UpdateStudentAffectationModal from "./UpdateStudentAffectationModal";
import CreateSlotChangeRequestModal from "../../slot-change-requests/components/CreateSlotChangeRequestModal";
import ContactStudentMailModal from "./ContactStudentMailModal";
import MeaLink from "../../../../components/MeaLink";
import { PERMISSION_TRAINING_CLASSES, PERMISSION_TRAINING_LEVELS, PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS, PERMISSION_TRAINING_STUDENT_OBSERVATIONS, PERMISSION_TRAINING_STUDENTS } from "../../../../permissions";
import { useAuthContext } from "../../../../hooks/useAuthContext";
import UpdateStudentResultModal from "../models/UpdateStudentResultModal";
import ChangeStudentStatusModal, { getAllowedStudentStatusTransitions } from "../models/ChangeStudentStatusModal";
import AddStudentObservationModal from "./AddStudentObservationModal";

const StudentDetailHeader = ({ student, schoolId, trainingId, callback }) => {

    const { hasPermission } = useAuthContext();
    //
    const menu11_1 = useRef(null);

    const updateResultModalRef = useRef();
    const changeStatusModalRef = useRef();
    const addObservationModalRef = useRef();

    const updateModalRef = useRef();
    const slotChangeModalRef = useRef();
    const contactMailModalRef = useRef();

    const getGender = () => {
        let gender = student?.gender;
        if (gender !== undefined) {
            if (gender === "G") {
                return "Fille";
            } else if (gender === "B") {
                return "Garçon";
            } else {
                return "-";
            }
        } else {
            return "-";
        }
    };

    const statusTransitions = getAllowedStudentStatusTransitions(student?.status);
    const refresh = () => callback?.();
    // Schooling actions only make sense for an enrolled (confirmed) student.
    const notEnrolled = student?.status !== "ENROLLED";

    const menuGroups = [
        {
            label: 'Scolarité',
            items: [
                {
                    label: "Changer le statut",
                    icon: 'pi pi-sync',
                    disabled: statusTransitions.length === 0,
                    command: () => changeStatusModalRef.current?.show(refresh),
                    hidden: !hasPermission(PERMISSION_TRAINING_REGISTRATION.UPDATE),
                },
                {
                    label: 'Changement de classe',
                    icon: 'pi pi-arrow-right-arrow-left',
                    disabled: notEnrolled,
                    command: () => updateModalRef.current?.show(student, refresh),
                    hidden: !hasPermission(PERMISSION_TRAINING_STUDENTS.UPDATE),
                },
                {
                    label: 'Demande de changement de créneau',
                    icon: 'pi pi-clock',
                    disabled: notEnrolled,
                    command: () => slotChangeModalRef.current?.show(refresh, student),
                    hidden: !hasPermission(PERMISSION_TRAINING_SLOT_CHANGE_REQUESTS.CREATE),
                },
            ],
        },
        {
            label: 'Suivi',
            items: [
                {
                    label: 'Nouvelle observation',
                    icon: 'pi pi-comment',
                    disabled: notEnrolled,
                    command: () => addObservationModalRef.current?.show(student),
                    hidden: !hasPermission(PERMISSION_TRAINING_STUDENT_OBSERVATIONS.CREATE),
                },
                {
                    label: 'Avis de passage',
                    icon: 'pi pi-angle-double-up',
                    disabled: notEnrolled,
                    command: () => updateResultModalRef.current?.show(refresh),
                    hidden: !hasPermission(PERMISSION_TRAINING_STUDENTS.UPDATE),
                },
            ],
        },
        {
            label: 'Communication',
            items: [
                {
                    label: 'Contacter par mail',
                    icon: 'pi pi-envelope',
                    command: () => contactMailModalRef.current?.show(),
                    hidden: !hasPermission(PERMISSION_TRAINING_STUDENTS.UPDATE),
                },
            ],
        },
    ];
    const menuItems = menuGroups
        .map((group) => ({ ...group, items: group.items.filter((item) => !item.hidden) }))
        .filter((group) => group.items.length > 0);

    return (
        <>
            <UpdateStudentAffectationModal
                ref={updateModalRef}
                student={student}
                schoolId={schoolId}
                trainingId={trainingId}
            />
            <CreateSlotChangeRequestModal
                ref={slotChangeModalRef}
                student={student}
                lockStudent={true}
                schoolId={schoolId}
                trainingId={trainingId}
            />
            <ContactStudentMailModal
                ref={contactMailModalRef}
                student={student}
                schoolId={schoolId}
                trainingId={trainingId}
            />
            <div className="surface-ground px-4 py-5 md:px-3 lg:px-3 shadow-3">
                <div className="flex align-items-start flex-row justify-content-between">
                    <div className="flex align-items-start flex-column md:flex-row">
                        <div className="flex align-items-start mr-3">

                            <img src={
                                student?.member?.avatar
                                    ? student?.member?.avatar + "?u=" + student?.member?.updated_at
                                    : "/user.png"
                            } className="mr-3 ml-3 mb-3 lg:mb-0" style={{ width: '90px', height: '90px', borderRadius: '50%' }} alt="Eleve" />
                        </div>
                        <div>
                            <span className="text-900 font-medium text-3xl uppercase">{
                                student?.member?.name ||
                                (student?.lastname || student?.member?.lastname || "") +
                                " " +
                                (student?.firstname || student?.member?.firstname || "")
                            }</span>
                            <span className="text-2xl ml-3 text-yellow-500"><MeaStudentStatus2 student={student} /></span>
                            <div className="flex align-items-center flex-wrap text-sm">
                                <div className="mr-5 mt-3">
                                    <span className="font-medium text-500">Genre</span>
                                    <div className="text-700 mt-2">{getGender()}</div>
                                </div>
                                <div className="mr-5 mt-3">
                                    <span className="font-medium text-500">Age</span>
                                    <div className="text-700 mt-2">{student?.age || "-"}</div>
                                </div>
                                {(student?.status !== "ENROLLED") &&
                                    <>
                                        <div className="mt-3">
                                            <span className="font-medium text-500">Immatriculation</span>
                                            <div className="text-700 mt-2">{student?.member?.id || "-"}</div>
                                        </div></> || <>
                                        <div className="mr-5 mt-3">
                                            <span className="font-medium text-500">Niveau</span>
                                            <div className="text-700 mt-2">
                                                <MeaLink
                                                    to={
                                                        "/school/" +
                                                        student?.school_id +
                                                        "/admin/trainings/" +
                                                        student?.training_id +
                                                        "/levels/" +
                                                        student?.level?.id
                                                    }
                                                    permission={PERMISSION_TRAINING_LEVELS.GET}
                                                >
                                                    {student?.level?.name}
                                                </MeaLink>
                                            </div>
                                        </div>
                                        <div className="mr-5 mt-3">
                                            <span className="font-medium text-500">Classe</span>
                                            <div className="text-700 mt-2">
                                                <MeaLink
                                                    to={
                                                        "/school/" +
                                                        student?.school_id +
                                                        "/admin/trainings/" +
                                                        student?.training_id +
                                                        "/classes/" +
                                                        student?.classe?.id
                                                    }
                                                    permission={PERMISSION_TRAINING_CLASSES.GET}
                                                >
                                                    {student?.classe?.name}
                                                </MeaLink>
                                            </div>
                                        </div>

                                        <div className="mr-5 mt-3">
                                            <span className="font-medium text-500">Photogaphié?</span>
                                            <div className="text-700 mt-2">{student?.authorized_take_photo ? <span className="pi pi-check text-green-500 text-sm" >OUI</span> : <span className="pi pi-times text-red-500 text-sm" >NON</span>}</div>
                                        </div>
                                        <div className="mr-5 mt-3">
                                            <span className="font-medium text-500">Partir seul?</span>
                                            <div className="text-700 mt-2">{student?.authorized_back_alone ? <span className="pi pi-check text-green-500 text-sm" >OUI</span> : <span className="pi pi-times text-red-500 text-sm">NON</span>}</div>
                                        </div>
                                        <div className="mr-5 mt-3">
                                            <span className="font-medium text-500">Avis de passage</span>
                                            <div className="text-700 mt-2"><MeaStudentResult student={student} /></div>
                                        </div>
                                    </>}

                            </div>
                        </div>
                    </div>
                    {menuItems.length > 0 && (
                        <div className="flex  mt-3 lg:mt-0">
                            <Menu ref={menu11_1} popup model={menuItems} id="student_actions_menu" />
                            <MeaButton
                                type="button"
                                text
                                raised
                                icon="pi pi-cog"
                                className="mr-2"
                                aria-label="Actions sur l'élève"
                                aria-controls="student_actions_menu"
                                aria-haspopup
                                onClick={(event) => menu11_1.current.toggle(event)}
                            />
                        </div>
                    )}

                </div>
            </div>
            <UpdateStudentResultModal ref={updateResultModalRef} student={student} schoolId={schoolId} trainingId={trainingId} />
            <ChangeStudentStatusModal ref={changeStatusModalRef} student={student} schoolId={schoolId} trainingId={trainingId} />
            <AddStudentObservationModal ref={addObservationModalRef} schoolId={schoolId} trainingId={trainingId} onCreated={refresh} />
        </>
    );
};

export default StudentDetailHeader;
